import React, { useState, useEffect } from "react";
import { LangContext } from "../contexts/LangContext";
import { useLang } from "../hooks/useLang";
import { getCookie, deleteCookie } from "../services/cookie";
import { AuthPage } from "./Auth/AuthPage";
import { Cabinet } from "./Cabinet/Cabinet";
import { VerifyEmailPage } from "./Auth/VerifyEmailPage";
import { ResetPasswordPage } from "./Auth/ResetPasswordPage";
import { Spinner } from "./Common/Spinner";

export default function App() {
  const { lang, setLang } = useLang();
  const [route, setRoute] = useState("loading");
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const path = window.location.pathname;
    
    if (path.startsWith("/verify-email")) {
      setRoute("verify-email");
      return;
    }
    
    if (path.startsWith("/reset-password")) {
      setRoute("reset-password");
      return;
    }

    const token = getCookie("authToken");
    const email = getCookie("userEmail");
    if (token) {
      setUserEmail(email || "");
      setRoute("cabinet");
    } else {
      setRoute("auth");
    }
  }, []);

  const handleLogin = (user) => {
    setUserEmail(user.email || getCookie("userEmail") || "");
    setRoute("cabinet");
  };

  const handleLogout = () => {
    deleteCookie("authToken");
    deleteCookie("userEmail");
    setUserEmail("");
    setRoute("auth");
  };

  const handleGoToLogin = () => {
    setRoute("auth");
  };

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {route === "loading" && <Spinner />}
      {route === "auth" && <AuthPage onLogin={handleLogin} />}
      {route === "cabinet" && (
        <Cabinet userEmail={userEmail} onLogout={handleLogout} />
      )}
      {route === "verify-email" && <VerifyEmailPage onGoToLogin={handleGoToLogin} />}
      {route === "reset-password" && <ResetPasswordPage onGoToLogin={handleGoToLogin} />}
    </LangContext.Provider>
  );
}